export function toDisplayCamelCase(value: string | null | undefined): string {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  return raw
    .toLowerCase()
    .split(/(\s+|\/|-|_|\.)/g)
    .map((part) => {
      if (!part || /^\s+$/.test(part) || /^[\/\-_.]$/.test(part)) return part;
      return part.charAt(0).toUpperCase() + part.slice(1);
    })
    .join("");
}
